if (!customElements.get("progress-bar")) {
	customElements.define(
		"progress-bar",
		class ProgressBar extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.drag = this.querySelector(".progress-bar__bar--drag");
				this.steps = this.querySelectorAll(".progress-bar__step");
				this.target = +this.dataset.target;

				if (this.steps) {
					this.handleStepsPlacement(this.steps);
				}
			}

			formatMoney(cents) {
				const euros = (cents / 100).toFixed(2).replace(".", ",");
				return `${euros}€`;
			}

			handleDragWidth(drag, cartTotalPrice) {
				const width = cartTotalPrice / +this.dataset.target;
				drag.style.width = `${width}%`;
				return drag;
			}

			handleMessage(instance, items, cartTotalPrice) {
				const messageLeft = instance.dataset.messageLeft;
				const messageSuccess = instance.dataset.messageSuccess;
				const cartPrice = cartTotalPrice / 100;
				const messageContainer = instance.querySelector(".progress-bar__title");
				const lastItemReached =
					cartPrice >= +items[items.length - 1].dataset.target;

				if (lastItemReached) {
					messageContainer.textContent = messageSuccess;
				} else {
					items.forEach((item) => {
						const target = +item.dataset.target;
						if (cartPrice >= target) return;

						const leftAmount = target - cartPrice;
						const formattedLeftAmount = `<strong>${this.formatMoney(
							leftAmount * 100
						)}</strong>`;
						messageContainer.innerHTML = messageLeft.replace(
							"€",
							formattedLeftAmount
						);
						return;
					});
				}
			}

			handleStepsPlacement(elements) {
				elements.forEach((element) => {
					const currTarget = +element.dataset.target;
					const left = (currTarget * 100) / this.target;
					element.style.left = `${left}%`;
				});
			}
		}
	);
}